// assets
import { IconDashboard } from "@tabler/icons-react";

// constant
const icons = { IconDashboard };
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const TransportStatuses = {
  id: "Transportation Status",
  title: "Transportation Status",
  type: "item",
  url: "/portal/admin/transport-statuses",
  icon: icons.IconDashboard,
};

export default TransportStatuses;
